var map = {
	"./Geva Hason - A Tale of Wind n_ Sails.mp3": 3268,
	"./Geva Hason - Blood Connection - Theme.mp3": 6687,
	"./Geva Hason - Circules - Theme Song.mp3": 4268,
	"./Geva Hason - Irish Violin.mp3": 8624,
	"./Geva Hason - Ma_agalim.mp3": 7111,
	"./Geva Hason - Middle Eastern Church.mp3": 1511,
	"./Geva Hason - Sax Groove.mp3": 9775,
	"./Geva Hason - Shoshke.mp3": 8878
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4036;